import { render } from "./PlanColumnView.vue?vue&type=template&id=1439bc2c&ts=true"
import script from "./PlanColumnView.vue?vue&type=script&lang=ts"
export * from "./PlanColumnView.vue?vue&type=script&lang=ts"

import "./PlanColumnView.vue?vue&type=style&index=0&id=1439bc2c&lang=css"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__